<template>
  <div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="trilhaMagneticaModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div
        class="modal-dialog mt-5"
        role="document"
        v-if="lendo"
      >
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title">
              <i class="fas fa-credit-card"></i>
              Identificação do Paciente
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <az-empty-state v-if="$store.state.loading" />
            <div v-else>

                <div class="row">
                    <div class="col col-12">
                        <az-input
                            type="button-group"
                            placeholder="Tipo..."
                            label="Tipo de indentificação do beneficiário"
                            optionsDisplay="search"
                            required
                            :optionsList="tipos_identificacao"
                            optionsData="id"
                            :validate="validate"
                            v-model="tipoAutoriz" />
                    </div>
                </div>

                <div class="row mt-3">
                    <!-- TRILHA -->
                    <div class="col col-12" v-if="tipoAutoriz == '1'">
                        <div
                            id="leitura_mag"
                            class="text-truncate text-nowrap bg-primary text-white p-2"
                            contenteditable="true"
                            @blur="perder_foco"
                            @keyup.prevent="leitura"
                        >
                        {{ exibicao }}
                        </div>
                    </div>
                    <!-- TOKEN -->
                    <div class="col col-12" v-else>
                        <az-input
                            type="number"
                            placeholder="Informe o Token..."
                            v-model="token"
                            >
                            <template slot="buttonposb">
                                <button class="btn btn-primary" type="button" @click="leitura_token">
                                    <i class="fas fa-check fa-fw"></i>
                                </button>

                            </template>
                        </az-input>
                    </div>
                </div>
                <template v-if="tokenRequerido">
                    <div class="row">
                        <div class="col col-12">
                            <az-input
                                label="Não possuo token?"
                                type="checkbox-group"
                                :validate="validate"
                                v-model="nao_possui_token"
                            />
                        </div>
                    </div>
                    <div class="row" v-if="nao_possui_token">
                        <div class="col col-12">
                            <az-input
                                type="select"
                                placeholder="Motivo..."
                                label="Motivo ausência de token"
                                optionsDisplay="search"
                                required
                                :optionsList="[
                                    { id: '01', search: '01 - Beneficiário internado'},
                                    { id: '02', search: '02 - Beneficiário em situação de urgência/emergência' },
                                    { id: '03', search: '03 - Intermitência/Instabilidade de sistemas e regularização do atendimento após saída do beneficiário do prestador' },
                                    { id: '04', search: '04 - Beneficiário se negou a transmitir o número do token' },
                                    { id: '05', search: '05 - Beneficiário em coleta domiciliar' },
                                    { id: '06', search: '06 - Material para exames enviado ao prestador por terceiros' },
                                    { id: '07', search: '07 - Beneficiário não possui celular' }
                                ]"
                                optionsData="id"
                                v-model="nao_possui_token_motivo">
                            </az-input>
                        </div>
                    </div>
                </template>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Modal -->
    <div class="modal fade" id="autorizRetornoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Retorno Autorização</h5>
              <button type="button" class="close" @click="fechar('autorizRetornoModal')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <template v-if="trilha">
              <span>Trilha:
                <i class="fa fa-check text-success" aria-hidden="true" v-if="validar_trilha()"></i>
                <i class="fa fa-times text-danger" aria-hidden="true" v-if="!validar_trilha()"></i>
              </span>

              <pre class="alert alert-info">{{ trilha }}</pre>
            </template>

            <p class="alert alert-danger" v-if="retorno && retorno.error">
              {{ retorno.msg }}
            </p>

            <pre class="alert alert-warning" v-if="retorno && retorno.trilha">{{ retorno.trilha }}</pre>

            <pre class="alert alert-secondary" v-if="retorno && retorno.log">{{ retorno.log }}</pre>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="fechar('autorizRetornoModal')">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="consultaAutorizacaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Consulta Autorização
                      <small class="text-muted ml-3" v-if="item">#{{ item.id_solicitacao_autorizacao }}</small>
                    </h5>
                    <button type="button" class="close" @click="fechar('consultaAutorizacaoModal')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                  <template v-if="!item">
                    Carregando
                  </template>

                  <template v-if="item">

                    <az-input
                        :label="item.fl_apac ? 'Nümero da APAC' : 'Número da Autorização / Senha'"
                        required
                        :validate="validate"
                        :edicao="item.in_status == 0"
                        v-model="item.st_codigo_autorizacao" />

                    <az-input
                        label="Número da guia na operadora"
                        :validate="validate"
                        :edicao="item.in_status == 0"
                        v-model="item.st_guia_operadora" />

                    <az-input
                        label="Data da Autorização"
                        type="date"
                        required
                        :validate="validate"
                        :edicao="item.in_status == 0"
                        v-model="item.dt_autorizacao" />

                    <az-input
                        label="Validade De..."
                        type="date"
                        required
                        :validate="validate"
                        :edicao="item.in_status == 0"
                        v-model="item.dt_valid_inicio" />

                    <az-input
                        label="Validade Até..."
                        type="date"
                        required
                        :validate="validate"
                        :edicao="item.in_status == 0"
                        v-model="item.dt_valid_termino" />

                    <az-input
                        label="Comentários"
                        type="textarea"
                        rows="3"
                        :edicao="item.in_status == 0"
                        :validate="validate"
                        v-model="item.st_comentarios" />

                  </template>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="fechar('consultaAutorizacaoModal')">Fechar</button>
                </div>
            </div>
        </div>
    </div>

    <az-dispatch ref="dispatch" titulo="Processando robô de autorização" />
  </div>
</template>

<script>
import $ from "jquery";
import AzEmptyState from "../../util/AzEmptyState.vue";
import AzInput from '../../shared/forms/AzInput.vue';
import AzDispatch from '../../util/AzDispatch.vue';
import { subscribe, unSubscribe } from "../../../service/Notify";

export default {
  data() {
    return {
      trilha: "",
      lendo: false,
      terminou: false,
      solic: null,
      guia: null,
      retorno: null,
      item: null,
      validate: false,
      tipoAutoriz: '1',
      token: null,
      callback_lote: null,
      timeout_fn: null,
      nao_possui_token: false,
      nao_possui_token_motivo: null,
      bradesco_cartao_gerado: false,
    };
  },

  components: {
    AzEmptyState,
    AzInput,
    AzDispatch
  },

  computed: {
    exibicao: function() {
      return this.trilha
        ? "Leitura de Cartão... (" + this.trilha.length + ")"
        : "Passe o cartão...";
      },

    tokenRequerido: function() {
        if (this.solic) {
            return this.solic.plano.operadora.st_registro_ans == "326305";
        } else if(this.marcacao) {
            return this.marcacao.plano.operadora.st_registro_ans == "326305";
        }

        return false;
    },

    tipos_identificacao: function() {
        if (this.tokenRequerido) {
            return [
                { id: '2', search: 'Token' }
            ];
        } else {
            return [
                { id: '1', search: 'Cartão magnético' },
                { id: '2', search: 'Token' }
            ];
        }
    }

  },

  methods: {
    fechar(modal) {
      $('#' + modal).modal('hide');
    },

    perder_foco() {
      if (!this.terminou) {
        //$("#trilhaMagneticaModal").modal("hide");
      }
    },

    leitura(e) {
      let leitura_input = $("#leitura_mag");

      if (leitura_input) leitura_input[0].innerText = this.exibicao;

      if (e.location) return;

      if (e.key == "Enter") {
        this.trilha = this.trilha + "\n";
      } else if (e.key.length == 1) {
        this.trilha = this.trilha + e.key;
      }

      const teste = this.trilha.match(/\n/g);

      if (teste && teste.length >= 2) {
        $("#trilhaMagneticaModal").modal("hide");
        this.terminou = true;

        if ( !this.validar_trilha(teste) ) {

          this.$toast.add({
            severity: "error",
            summary: "Atenção",
            detail: "Erro na leitura do cartão.",
            life: 5000
          });

          return;

        }

        clearTimeout(this.timeout_fn);

        if(this.callback_lote) {
            $("#trilhaMagneticaModal").modal("show");
            this.$nextTick(() => {

                this.callback_lote();
                return;
            });
        } else {
            this.autorizar_solicitacao_com_trilha(this.guia);
        }

      }
    },

    leitura_token() {

        if (this.tokenRequerido) {

            if (!this.token && !this.nao_possui_token) {
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Informe o token corretamente.",
                    life: 5000
                });

                return;
            }

            if(this.nao_possui_token && !this.nao_possui_token_motivo) {
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Informe o motivo da ausência do token.",
                    life: 5000
                });

                return;
            }
            

        } else {

            if (!this.token) {
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Informe o token corretamente.",
                    life: 5000
                });

                return;
            }

        }

        this.trilha = this.token;
        this.terminou = true

        clearTimeout(this.timeout_fn);

        if(this.callback_lote) {
            $("#trilhaMagneticaModal").modal("hide");
            this.$nextTick(() => {
                this.callback_lote();
                return;
            });
        } else {
            this.autorizar_solicitacao_com_trilha(this.guia);
        }

    },

    validar_trilha() {
      let trilha = this.trilha.split('\n');

      if ( !trilha || trilha.length <= 2 )
        return false;

      if ( !trilha[0].trim() || !trilha[1].trim() )
        return false;

      if ( trilha[0].substr(2, 15) != trilha[1].substr(1, 15) )
        return false;

      return true;
    },

    verificar_servico_online(plano, callback) {

        if (!plano.servico_online) {
            this.$util.loadItem(this, {
                service: "operadoras",
                func: "show",
                configs: ['autorizacao-bradesco-cartao-gerado'],
                parms: {
                    id: plano.operadora.id_operadora,
                    service_online: true,
                },
            }).then((res) => {
                if (res && res.is_overmind) {
                    plano.servico_online = 'OVERMIND';
                } else {
                    plano.servico_online = '?';
                }

                this.bradesco_cartao_gerado = !!this.$store.state.contexto['autorizacao-bradesco-cartao-gerado'];

                callback(plano);

            });

        } else {
            callback(plano);
        }

    },

    tem_trilha(plano, marcacao = null) {
      if (plano.servico_online == 'OVERMIND') {
        return false;
      }

      console.log('marcacao', plano, marcacao);

      switch (plano.operadora.st_registro_ans) {
        case "005711":
            return (marcacao && marcacao.atendimento && marcacao.atendimento.id_tipo_atendimento == 7)
                ? false
                : !this.bradesco_cartao_gerado;
            
        case "421715":
          return (marcacao && marcacao.atendimento && marcacao.atendimento.id_tipo_atendimento == 7) ? false : true;
        // AMIL - não pedir o token para amil
        // case "326305":
        //     this.tipoAutoriz = '2';
        //     return true;
      }

      return false;
    },

    uuidv4() {
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },  

    clear() {
      this.terminou = false;
      this.lendo = true;
      this.trilha = "";
      this.token = "";
      this.callback_lote = null;
      clearTimeout(this.timeout_fn);
      this.timeout_fn = null;
      this.$store.commit('loading', false);
    },

    abrir(callback = null) {
      this.terminou = false;
      this.lendo = true;
      this.trilha = "";
      this.token = "";
      this.callback_lote = callback;

      this.$nextTick(() => {
        $("#trilhaMagneticaModal").modal("show");

        this.timeout_fn = setTimeout(() => {
          let p = document.getElementById("leitura_mag");
          let s = window.getSelection();
          let r = document.createRange();
          r.setStart(p, p.childElementCount);
          r.setEnd(p, p.childElementCount);
          s.removeAllRanges();
          s.addRange(r);
        }, 500);
      });
    },

    consultar (solic) {
      this.item = solic;
      this.validate = false;
      $('#consultaAutorizacaoModal').modal('show');
    },

    enviar_documentos (solic) {
      this.item = solic;
      this.validate = false;

      if (confirm("Deseja enviar os documentos para a autorização online?")) {

        this.$util.atualizar(this, {
            service: 'solicitacao_autorizacoes',
            func: 'enviar_documentos',
            redir_api: true,
            dados: {
              id_solicitacao_autorizacao: solic.id_solicitacao_autorizacao,
            },
            callback: (res) => {
              this.$toast.add({
                severity: (res.status_code && res.status_code == 200) ? "success" : "error",
                summary: "Atenção",
                detail: res.msg,
                life: 3000
              });

              this.$emit("refresh");
            }
          });
      }
    },

    autorizar_solicitacao_com_trilha(guia = null, callback = null) {

      // redir_api: true,

      /*
      id_marcacao: guia
        ? null
        : this.marcacao
        ? this.marcacao.id_marcacao
        : null,
      */
      if (this.tokenRequerido) {
        this.trilha = null;
      }

      this.$util.atualizar(this, {
        service: "solicitacao_autorizacoes",
        func: "solicitacao_procedimentos",
        redir_api: true,
        continue_loading: callback != null,
        dados: {
          id_solicitacao_autorizacao: this.solic
            ? this.solic.id_solicitacao_autorizacao
            : null,
          id_guia: guia ? guia.id_guia : null,
          trilha: this.trilha,
          token: this.token,
          motivo_nao_token: this.nao_possui_token ? this.nao_possui_token_motivo : null,
        },
        callback: res => {
          if (res.status_code && !res.error) {

            if (res.robo_autorizacao) {
                // this.$store.commit('loading', true);
                this.$nextTick(() => {
                    this.$refs.dispatch.show_modal();
                    subscribe(res.robo_autorizacao, 'retorno-robo', retorno => {
                        console.log('robo autorização: ', retorno);

                        this.$store.commit('loading', false);
                        this.$refs.dispatch.hide_modal();
                        unSubscribe(res.robo_autorizacao, 'retorno-robo');
                        if (retorno.data && retorno.data.ok) {
                            this.$toast.add({
                                severity: "success",
                                summary: "Atenção",
                                detail: retorno.data.msg,
                                life: 7000
                            });
                        } else {
                            this.$toast.add({
                                severity: "error",
                                summary: "Atenção",
                                detail: retorno.data.error,
                            });
                        }
                    });
                });
            }

            this.$toast.add({
              severity: "success",
              summary: "Atenção",
              detail: res.msg,
              life: 7000
            });

            if(res.msg_profissionais) {
              this.$toast.add({
                severity: "warn",
                summary: "Atenção",
                detail: res.msg_profissionais,
            });

          }

          } else {

            this.$toast.add({
              severity: "error",
              summary: "Atenção",
              detail: res.msg,
            });

          }

          this.retorno = res;

          this.$emit("refresh");
          if(callback) callback(res);
        },

        error: (res) => {
          if(callback) callback(res);
        },

        final: () => {
          $("#trilhaMagneticaModal").modal("hide");

          if ( this.$store.state.user.id_usuario == 1 ) {
            $('#autorizRetornoModal').modal('show');
          }

        }
      });
    },

    autorizar_solicitacao(solic) {
      this.solic = solic;

        this.verificar_servico_online(solic.plano, () => {
            if (this.tem_trilha(solic.plano)) {
                this.token = '';
                this.abrir();
                return;
            }

            if (confirm("Confirmar realizar a autorização online de procedimento?")) {
                this.autorizar_solicitacao_com_trilha();
            }
        });
    },

    autorizar_marcacao(marcacao) {
        this.marcacao = marcacao;

        this.verificar_servico_online(marcacao.plano, () => {
            if (this.tem_trilha(marcacao.plano, marcacao)) {
                this.token = '';
                this.abrir();
                return;
            }

            if (confirm("Confirmar realizar a autorização online de procedimento?")) {
                this.autorizar_solicitacao_com_trilha();
            }
        });
    },

    autorizar_guia(marcacao, guia, confirmar = true, callback = null) {
      this.marcacao = marcacao;
      this.guia = guia;

      this.verificar_servico_online(marcacao.plano, () => {
        if (this.tem_trilha(marcacao.plano, marcacao) && this.callback_lote == null) {
            this.abrir();
            return;
        }

        if (confirmar) {
            if (confirm("Confirmar realizar a autorização online de procedimento?")) {
            this.autorizar_solicitacao_com_trilha(guia, callback);
            }
        } else {
            this.autorizar_solicitacao_com_trilha(guia, callback);
        }
      });

    //   if (confirm("Confirmar realizar a autorização online de procedimento?")) {
    //     this.autorizar_solicitacao_com_trilha(guia);
    //   }
    },

    consultar_online(solic, callback = null) {
      if (confirm("Deseja consultar o status a autorização online?")) {

        //redir_api: true,

        this.$util.atualizar(this, {
            service: 'solicitacao_autorizacoes',
            func: 'status_autorizacao',
            redir_api: true,
            dados: {
              id_solicitacao_autorizacao: solic.id_solicitacao_autorizacao,
            },
            callback: (res) => {
              this.$toast.add({
                severity: (res.status_code && res.status_code == 200) ? "success" : "error",
                summary: "Atenção",
                detail: res.msg,
                life: 3000
              });

              this.$emit("refresh");
              if ( callback ) {
                callback(res);
              }
            }
          });
      }
    },

    cancelar_online(solic, callback = null) {
      if (confirm("Deseja cancelar a autorização Online?")) {
        // redir_api: true,

        this.$util.atualizar(this, {
              service: 'solicitacao_autorizacoes',
              func: 'cancelamento_autorizacao',
              redir_api: true,
              dados: {
                  id_solicitacao_autorizacao: solic.id_solicitacao_autorizacao,
              },
              callback: (res) => {
                  this.$toast.add({
                    severity: (res.status_code && res.status_code == 200) ? "success" : "error",
                    summary: "Atenção",
                    detail: res.msg,
                    life: 3000
                });

                this.$emit("refresh");
                if ( callback ) {
                  callback(res);
                }
              }
        });
      }
    },
  }
};
</script>